/**
 * @typedef NationalAccessibility
 * @property {'RUS'} RUS
 * @property {'EAEU'} EAEU
 * @property {'OTHER'} OTHER
 */

/** @type {Readonly<NationalAccessibility>} */
const nationalAccessibility = {
  RUS: 'RUS',
  EAEU: 'EAEU',
  OTHER: 'OTHER',
};

module.exports = nationalAccessibility;
